import { render } from "./ProgrammaLavoro.vue?vue&type=template&id=8c905b9e&scoped=true&ts=true"
import script from "./ProgrammaLavoro.vue?vue&type=script&lang=ts"
export * from "./ProgrammaLavoro.vue?vue&type=script&lang=ts"

import "./ProgrammaLavoro.vue?vue&type=style&index=0&id=8c905b9e&scoped=true&lang=css"

import exportComponent from "/Users/andrea/Sites/app_apib/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c905b9e"]])

export default __exports__